// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Gilroy" -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  font-size: calc(1rem + 0.4vw);
}

label {
  font-size: 1.4rem;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

input:not([type]),
input[type="text"]:not(.browser-default),
input[type="password"]:not(.browser-default),
input[type="email"]:not(.browser-default),
input[type="url"]:not(.browser-default),
input[type="time"]:not(.browser-default),
input[type="date"]:not(.browser-default),
input[type="datetime"]:not(.browser-default),
input[type="datetime-local"]:not(.browser-default),
input[type="tel"]:not(.browser-default),
input[type="number"]:not(.browser-default),
input[type="search"]:not(.browser-default),
textarea.materialize-textarea {
  height: 5.4rem;
  font-size: 1.6rem;
}

select {
  height: 5.4rem;
}

.btn i,
.btn-large i,
.btn-small i,
.btn-floating i,
.btn-large i,
.btn-small i,
.btn-flat i {
  font-size: 2rem;
}

.hidden {
  opacity: 0;
  width: 0px;
  overflow: hidden;
  position: absolute;
}

.card-table {
  border-collapse: separate;
  border-spacing: 1rem;
  word-break: break-word;
}

.card-table th {
  word-break: initial;
  font-weight: normal;
}

.card-table thead th {
  word-break: initial;
  font-weight: bold;
}

.card-table > tbody > tr {
  border: none;
  box-shadow: 0 2px 2px 0 #00000024, 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
}

.card-table > thead > tr {
  box-shadow: none;
}

button:focus-visible {
  outline: -webkit-focus-ring-color auto 1px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;;;;;;;;EAaE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ;gCAC8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: \"Gilroy\" -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\r\n    \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\r\n    sans-serif;\r\n  font-weight: 400;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  min-height: 100%;\r\n  font-size: calc(1rem + 0.4vw);\r\n}\r\n\r\nlabel {\r\n  font-size: 1.4rem;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\r\n    monospace;\r\n}\r\n\r\ninput:not([type]),\r\ninput[type=\"text\"]:not(.browser-default),\r\ninput[type=\"password\"]:not(.browser-default),\r\ninput[type=\"email\"]:not(.browser-default),\r\ninput[type=\"url\"]:not(.browser-default),\r\ninput[type=\"time\"]:not(.browser-default),\r\ninput[type=\"date\"]:not(.browser-default),\r\ninput[type=\"datetime\"]:not(.browser-default),\r\ninput[type=\"datetime-local\"]:not(.browser-default),\r\ninput[type=\"tel\"]:not(.browser-default),\r\ninput[type=\"number\"]:not(.browser-default),\r\ninput[type=\"search\"]:not(.browser-default),\r\ntextarea.materialize-textarea {\r\n  height: 5.4rem;\r\n  font-size: 1.6rem;\r\n}\r\n\r\nselect {\r\n  height: 5.4rem;\r\n}\r\n\r\n.btn i,\r\n.btn-large i,\r\n.btn-small i,\r\n.btn-floating i,\r\n.btn-large i,\r\n.btn-small i,\r\n.btn-flat i {\r\n  font-size: 2rem;\r\n}\r\n\r\n.hidden {\r\n  opacity: 0;\r\n  width: 0px;\r\n  overflow: hidden;\r\n  position: absolute;\r\n}\r\n\r\n.card-table {\r\n  border-collapse: separate;\r\n  border-spacing: 1rem;\r\n  word-break: break-word;\r\n}\r\n\r\n.card-table th {\r\n  word-break: initial;\r\n  font-weight: normal;\r\n}\r\n\r\n.card-table thead th {\r\n  word-break: initial;\r\n  font-weight: bold;\r\n}\r\n\r\n.card-table > tbody > tr {\r\n  border: none;\r\n  box-shadow: 0 2px 2px 0 #00000024, 0 3px 1px -2px rgb(0 0 0 / 12%),\r\n    0 1px 5px 0 rgb(0 0 0 / 20%);\r\n}\r\n\r\n.card-table > thead > tr {\r\n  box-shadow: none;\r\n}\r\n\r\nbutton:focus-visible {\r\n  outline: -webkit-focus-ring-color auto 1px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
